import { mapState, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapState('app', ['permissions']),
    ...mapGetters({ isFeatureFlagEnabled: 'app/isFeatureFlagEnabled' }),
    dataSources() {
      return [
        {
          type: 'iothub',
          name: this.$i18n_t('Common.drawer.iotDataHub'),
          image: './img/themes/n20/icon.png',
        },
        {
          type: 'iothub-aggregate',
          name: this.$i18n_t('DigitalTwin.DigitalTwin.states.dataSources.iothub-aggregate'),
          image: './img/themes/n20/icon.png',
        },
      ]
        .concat([
          this.permissions['VirtualDevice.list'] ||
          this.permissions['VirtualDevice.read'] ||
          this.permissions['VirtualDevice.manage']
            ? { type: 'virtual-device', name: this.$i18n_t('DigitalTwin.VirtualDevice.title'), icon: 'sensor-on' }
            : {},
        ])
        .concat([
          this.permissions['VirtualDevice.list'] ||
          this.permissions['VirtualDevice.read'] ||
          this.permissions['VirtualDevice.manage']
            ? {
                type: 'virtual-device-aggregate',
                name: this.$i18n_t('DigitalTwin.VirtualDevice.aggregation'),
                icon: 'sensor-on',
              }
            : {},
        ])
        .concat([
          {
            type: 'bridge',
            name: this.$i18n_t('DigitalTwin.DigitalTwin.states.dataSources.bridge'),
            icon: 'plug',
          },
          {
            type: 'aggregate',
            name: this.$i18n_t('DigitalTwin.DigitalTwin.states.dataSources.aggregate'),
            icon: 'layer-group',
          },
          {
            type: 'timeseries-aggregate',
            name: this.$i18n_t('DigitalTwin.DigitalTwin.states.dataSources.timeseries-aggregate'),
            icon: 'history',
          },
          {
            type: 'none',
            name: this.$i18n_t('DigitalTwin.DigitalTwin.states.dataSources.none'),
            icon: 'save',
          },
          {
            type: 'random',
            name: this.$i18n_t('DigitalTwin.DigitalTwin.states.dataSources.random'),
            icon: 'dice',
          },
          {
            type: 'dynamical-data-routing',
            name: this.$i18n_t('DigitalTwin.DigitalTwin.states.dataSources.datarouting'),
            icon: 'route',
          },
        ])
        .filter((s) => s.type)
        .map((s) => {
          return { ...s, name: (this.sourcesNameMapping || {})[s.type] || s['name'] };
        });
    },
  },
};
